// Treatments.js
import { useEffect, useState, useRef } from "react";
import TreatmentUI from "./TreatmentUI";
import * as toast from "../../Wrapper/toast/toast";
import * as apiHelper from "../../Services/ApiHelper";
import * as stringConstants from "../../Constants/stringConstants";
import { changeDateFormatForServer } from "../../Utils/dateUtils";
import * as stringUtils from "../../Utils/stringUtils";
import * as commonServices from "../../Services/common";

import * as storageConstants from "../../Constants/storageConstant";
const Treatments = () => {
  const [modalShow, setModalShow] = useState(false);
  const [treatmentList, setTreatmentList] = useState([]);
  const [dates, setDates] = useState({ startDate: null, endDate: null });
  const [searchQuery, setSearchQuery] = useState("");
  const [lastSelectedPage, setLastSelectedPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [importModal, setImportModal] = useState(false);
  const [importList, setImportList] = useState();
  const [selectedRows, setSelectedRows] = useState([]);

  const datePickerStartRef = useRef();
  const datePickerEndRef = useRef();

  const handleClose = () => {
    setModalShow(false);
    clearData();
  };

  const initialAddTreatmentData = {
    name: "",
    default_qty: 1,
    description: "",
    action: "Add",
    id: null,
    status: "",
  };
  const [addTreatmentData, setAddTreatmentData] = useState(initialAddTreatmentData);

  useEffect(() => {
    const last_visited_page = commonServices.getLocalData(storageConstants.LAST_VISITED_PAGE) || {};
    const treatmentState = last_visited_page["treatments"] || null;

    if (treatmentState) {
      if (treatmentState.dates) setDates(treatmentState.dates);
      if (treatmentState.searchQuery) setSearchQuery(treatmentState.searchQuery);
      if (treatmentState.page) setLastSelectedPage(treatmentState.page);
    }
  }, []);

  useEffect(() => {
    const last_visited_page = commonServices.getLocalData(storageConstants.LAST_VISITED_PAGE) || {};
    last_visited_page["treatments"] = {
      dates,
      searchQuery,
      page: lastSelectedPage,
    };
    commonServices.storeLocalData(storageConstants.LAST_VISITED_PAGE, last_visited_page);
  }, [dates, searchQuery, lastSelectedPage]);

  useEffect(() => {
    if (
      (dates.startDate !== null && dates.endDate !== null) ||
      (dates.startDate === null && dates.endDate === null)
    ) {
      getTreatmentList(lastSelectedPage);
    }
  }, [dates]);

  const onPageChange = (page) => {
    getTreatmentList(page);
  };

  const getTreatmentList = (page = 1) => {
    const query = `?page=${page}&limit=10&start_date=${changeDateFormatForServer(dates.startDate)}&end_date=${changeDateFormatForServer(dates.endDate)}&q=${searchQuery}`;
    setLoading(true);
    setLastSelectedPage(page);
    apiHelper
      .getTreatmentList(query)
      .then((response) => {
        if (response?.isSuccess) {
          setTreatmentList(response?.data);
        } else {
          toast.warn(response?.message);
        }
      })
      .catch((err) => toast.warn(err))
      .finally(() => setLoading(false));
  };

  const clearData = () => {
    setAddTreatmentData(initialAddTreatmentData);
  };

  const validateData = () => {
    const { name, default_qty } = addTreatmentData;
    let validData = true;

    if (stringUtils.isNullOrEmpty(name)) {
      toast.warn(stringConstants.NAME_REQUIRED("Treatment"));
      validData = false;
    } else if (!stringUtils.isValidName(name)) {
      toast.warn(stringConstants.TREATMENT_NAME_LENGTH);
      validData = false;
    } else if (stringUtils.isNullOrEmpty(default_qty)) {
      toast.warn(stringConstants.QUANTITY_REQUIRED);
      validData = false;
    }
    return validData;
  };

  const addTreatment = () => {
    if (validateData()) {
      const { name, default_qty, description } = addTreatmentData;
      setButtonLoading(true);
      apiHelper
        .addTreatment({ name, default_qty, description })
        .then((response) => {
          if (response?.isSuccess) {
            getTreatmentList(lastSelectedPage);
            commonServices.fetchSystemData();
            toast.success(response.message);
            setModalShow(false);
            clearData();
            setButtonLoading(false);
          } else {
            setModalShow(false);
            setButtonLoading(false);
            toast.warn(response?.message);
          }
        })
        .catch((error) => {
          setModalShow(false);
          toast.warn(error.message);
        })
        .finally(() => setButtonLoading(false));
    }
  };

  const Action = (data, action = "") => {
    if (action === "edit") {
      setAddTreatmentData({
        name: data.name,
        default_qty: parseInt(data.default_qty),
        description: data.description,
        action: "Edit",
        id: data.id,
      });
      setModalShow(true);
    }
  };

  const editTreatment = (id) => {
    if (validateData()) {
      const { name, default_qty, description } = addTreatmentData;
      setButtonLoading(true);
      apiHelper.editTreatment(id, { name, default_qty, description }).then((response) => {
        if (response?.isSuccess) {
          getTreatmentList(lastSelectedPage);
          commonServices.fetchSystemData();
          toast.success(response.message);
          setModalShow(false);
          clearData();
          setButtonLoading(false);
        } else {
          toast.warn(response?.message);
          setButtonLoading(false);
        }
      });
    }
  };

  const statusHandler = (data) => {
    const updatedStatus = data.status === 1 ? 0 : 1;
    setAddTreatmentData({ ...addTreatmentData, status: updatedStatus });
    setButtonLoading(true);

    apiHelper
      .changeTreatmentStatus(data.id, { status: updatedStatus })
      .then((response) => {
        if (response?.isSuccess) {
          getTreatmentList(lastSelectedPage);
          commonServices.fetchSystemData();
          toast.success(response.message);
          setModalShow(false);
          clearData();
          setButtonLoading(false);
        } else {
          toast.warn(response?.message);
        }
      })
      .finally(() => setButtonLoading(false));
  };

  const importListing = (data) => {
    if (importModal) {
      setLoading(true);
      apiHelper
        .importMaster("treatment", data)
        .then((response) => {
          if (response?.isSuccess) {
            setImportList(response?.data);
          }
        })
        .catch((err) => toast.warn(err))
        .finally(() => setLoading(false));
    }
  };

  const openImportModal = () => {
    setImportModal(true);
  };

  const exportList = () => {
    setButtonLoading(true);
    apiHelper
      .exportMaster("treatment", { ids: selectedRows })
      .then((response) => {
        if (response?.isSuccess) {
          toast.success(response?.message);
          getTreatmentList(lastSelectedPage);
          commonServices.fetchSystemData(setLoading);
        } else {
          toast.warn(response.message);
        }
      })
      .catch((err) => toast.warn(err))
      .finally(() => {
        setButtonLoading(false);
        setImportModal(false);
      });
  };

  return (
    <TreatmentUI
      modalShow={modalShow}
      setModalShow={setModalShow}
      handleClose={() => {
        setModalShow(false);
        clearData();
      }}
      treatmentList={treatmentList}
      addTreatmentData={addTreatmentData}
      setAddTreatmentData={setAddTreatmentData}
      dates={dates}
      setDates={setDates}
      datePickerStartRef={datePickerStartRef}
      datePickerEndRef={datePickerEndRef}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      addTreatment={addTreatment}
      onPageChange={onPageChange}
      editTreatment={editTreatment}
      loading={loading}
      buttonLoading={buttonLoading}
      Action={Action}
      showConfirmModal={showConfirmModal}
      setShowConfirmModal={setShowConfirmModal}
      getTreatmentList={getTreatmentList}
      statusHandler={statusHandler}
      importListing={importListing}
      exportList={exportList}
      importModal={importModal}
      importList={importList}
      selectedRows={selectedRows}
      setSelectedRows={setSelectedRows}
      setImportModal={setImportModal}
      openImportModal={openImportModal}
    />
  );
};

export default Treatments;
